"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElasticUsageType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ElasticUsageType_Factory = /** @class */ (function () {
    function ElasticUsageType_Factory() {
    }
    ElasticUsageType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    ElasticUsageType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return ElasticUsageType_Factory;
}());
exports.ElasticUsageType_Factory = ElasticUsageType_Factory;
